import GoToTop from './GoToTop'

export default GoToTop